import React from 'react';
import { Block, BLOCKS, Inline, INLINES } from '@contentful/rich-text-types';

import { usePageDataContext } from '../../../../context/PageData';

import RichText from '../../../RichText';
import { EmbeddedInlineEntryNode } from '~/components/RichText/Nodes';
import Link from '../../../Link';

export function Disclaimers() {
  const {
    config: { footerDisclaimer } = {},
    articleConfig: {
      learningCenterGlobalDisclaimer,
      addFooterToGlobalConfigFooter
    } = {}
  } = usePageDataContext();

  if (addFooterToGlobalConfigFooter && learningCenterGlobalDisclaimer) {
    // Merge the two Contentful Document objects if both exist
    const mergedDisclaimer = {
      ...footerDisclaimer,
      content: [
        ...(footerDisclaimer?.content || []),
        ...(learningCenterGlobalDisclaimer?.content || [])
      ]
    };

    return (
      <RichText
        data={mergedDisclaimer as any}
        overrideOptions={{
          [INLINES.HYPERLINK]: (node, children) => (
            <Link
              href={node.data.uri}
              className="font-normal text-on-screen-surface-dark underline transition-colors duration-200 hover:text-[#00D9B4]"
            >
              {children}
            </Link>
          ),
          [INLINES.EMBEDDED_ENTRY]: (node, children) => (
            <EmbeddedInlineEntryNode node={node} colour="white">
              {children}
            </EmbeddedInlineEntryNode>
          ),
          [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => (
            <p className="mt-3 text-xs font-normal text-on-screen-surface-dark tablet:text-sm">
              {children}
            </p>
          )
        }}
      />
    );
  } else if (!addFooterToGlobalConfigFooter && learningCenterGlobalDisclaimer) {
    // Only use the learningCenterGlobalDisclaimer if addFooterToGlobalConfigFooter is false  and learningCenterGlobalDisclaimer exists
    const mergedDisclaimer = {
      ...footerDisclaimer,
      content: [...(learningCenterGlobalDisclaimer?.content || [])]
    };
    return (
      <RichText
        data={mergedDisclaimer as any}
        overrideOptions={{
          [INLINES.HYPERLINK]: (node, children) => (
            <Link
              href={node.data.uri}
              className="font-normal text-on-screen-surface-dark underline transition-colors duration-200 hover:text-[#00D9B4]"
            >
              {children}
            </Link>
          ),
          [INLINES.EMBEDDED_ENTRY]: (node, children) => (
            <EmbeddedInlineEntryNode node={node} colour="white">
              {children}
            </EmbeddedInlineEntryNode>
          ),
          [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => (
            <p className="mt-3 text-xs font-normal text-on-screen-surface-dark tablet:text-sm">
              {children}
            </p>
          )
        }}
      />
    );
  } else {
    return (
      <RichText
        data={footerDisclaimer}
        overrideOptions={{
          [INLINES.HYPERLINK]: (node, children) => (
            <Link
              href={node.data.uri}
              className="font-normal text-on-screen-surface-dark underline transition-colors duration-200 hover:text-[#00D9B4]"
            >
              {children}
            </Link>
          ),
          [INLINES.EMBEDDED_ENTRY]: (node, children) => (
            <EmbeddedInlineEntryNode node={node} colour="white">
              {children}
            </EmbeddedInlineEntryNode>
          ),
          [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => (
            <p className="mt-3 text-xs font-normal text-on-screen-surface-dark tablet:text-sm">
              {children}
            </p>
          )
        }}
      />
    );
  }
}
